
// Internal dependencies
import CPTMath from './cpt-math';

export default CPTMath;
